// src/components/Navbar.js
import React from 'react';


const Navbar = () => {
  return (
    <nav className="navbar">
      <ul>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#footer">Contact</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
